import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "placement", "onOpenChange", "isOpen", "playlistId", "trackId", "lessonId", "shortId", "language"];
import HR from 'UIComponents/elements/HR';
import { CardMenu, CardMenuFooterLink, CardMenuOptions } from '..';
import { CardMenuAddToPlaylistOption, CardMenuChangePlaylistThumbnailOption, CardMenuWatchLaterOption, CreatePlaylistLink, EditPlaylistButton, useUserOwnsPlaylist } from '../../savedItems';
import getLang from 'LearningCenterUI/utils/getLang';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import StartPlaylistButton from '../../savedItems/components/StartPlaylistButton';
import styled from 'academy-common-lib/utils/Styling';
import UsageTracker from '../../../utils/UsageTracker';
import { ShareButton, SocialShareMenuOption } from '../../share';
import { DuplicatePlaylistButton } from '../../savedItems/components/DuplicatePlaylistButton';
import { ArchivePlaylistButton, SavePlaylistButton } from '../../myPlaylists';
import { AssignPlaylistButton, CardMenuUnassignPlaylistOption } from '../../playlistAssignments';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CardStartPlaylistButton = styled(StartPlaylistButton).withConfig({
  displayName: "DesktopCardMenu__CardStartPlaylistButton",
  componentId: "zwhfxe-0"
})([".loading-spinner{position:relative !important;}"]);
const menuItemStyle = {
  textDecoration: 'none',
  fontWeight: 'normal',
  width: '100%'
};
const DesktopCardShareButton = shareButtonProps => /*#__PURE__*/_jsx(ShareButton, Object.assign({}, shareButtonProps, {
  render: button => /*#__PURE__*/_jsx(UISideNavItem, {
    role: "navigation-item",
    title: button
  })
}));
const trackCreateNewPlaylist = (itemId, type) => {
  UsageTracker.track('playlistInteraction', {
    action: 'add-to-new-playlist',
    location: 'card-menu',
    itemId,
    type
  });
};
const trackAddToPlaylist = (itemId, type) => {
  UsageTracker.track('playlistInteraction', {
    action: 'add-to-playlist',
    location: 'card-menu',
    itemId,
    type
  });
};
const trackUnassignedPlaylist = () => {
  UsageTracker.track('playlistInteraction', {
    action: 'playlist-unassigned',
    location: 'card-menu'
  });
};
const TrackLessonMenuOptions = ({
  trackId,
  lessonId,
  language = getLang(),
  closeModal
}) => {
  const onCreateNewClick = () => {
    trackCreateNewPlaylist(trackId || lessonId, trackId ? 'TRACK' : 'LESSON');
    closeModal();
  };
  const onAddToPlaylistClick = () => {
    trackAddToPlaylist(trackId || lessonId, trackId ? 'TRACK' : 'LESSON');
    closeModal();
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CardMenuWatchLaterOption, {
      lessonId: lessonId,
      onClick: closeModal,
      trackId: trackId
    }), /*#__PURE__*/_jsx(CardMenuAddToPlaylistOption, {
      language: language,
      lessonId: lessonId,
      onCreatePlaylistClick: onCreateNewClick,
      onPlaylistClick: onAddToPlaylistClick,
      trackId: trackId
    }), /*#__PURE__*/_jsx(HR, {
      distance: "extra-small"
    }), /*#__PURE__*/_jsx(DesktopCardShareButton, {
      language: language,
      lessonId: lessonId,
      onClick: closeModal,
      trackId: trackId
    })]
  });
};
const TrackLessonMenuFooter = ({
  trackId,
  lessonId,
  language = getLang(),
  closeModal
}) => {
  const onCreateNewClick = () => {
    closeModal();
    trackCreateNewPlaylist(trackId || lessonId, trackId ? 'TRACK' : 'LESSON');
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HR, {
      distance: "flush"
    }), /*#__PURE__*/_jsx(CreatePlaylistLink, {
      language: language,
      lessonId: lessonId,
      render: (content, to) => /*#__PURE__*/_jsx(CardMenuFooterLink, {
        onClick: onCreateNewClick,
        to: to,
        children: content
      }),
      trackId: trackId,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.cardMenu.addToNewPlaylist"
      })
    })]
  });
};
const PlaylistMenuOptions = ({
  playlistId,
  closeModal,
  language = getLang()
}) => {
  const userIsOwner = useUserOwnsPlaylist(playlistId);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UISideNavItem, {
      linkComponent: "div",
      title: /*#__PURE__*/_jsx(CardStartPlaylistButton, {
        appearsIn: "playlist",
        playlistId: playlistId,
        showLoader: true,
        style: menuItemStyle,
        use: "unstyled"
      })
    }), userIsOwner && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UISideNavItem, {
        linkComponent: "div",
        role: "navigation-item",
        title: /*#__PURE__*/_jsx(EditPlaylistButton, {
          playlistId: playlistId,
          style: menuItemStyle,
          use: "unstyled"
        })
      }), /*#__PURE__*/_jsx(CardMenuChangePlaylistThumbnailOption, {
        onItemClick: closeModal,
        playlistId: playlistId
      }), /*#__PURE__*/_jsx(HR, {
        distance: "extra-small"
      })]
    }), /*#__PURE__*/_jsx(DesktopCardShareButton, {
      onClick: closeModal,
      playlistId: playlistId
    }), /*#__PURE__*/_jsx(UISideNavItem, {
      linkComponent: "div",
      role: "navigation-item",
      title: /*#__PURE__*/_jsx(AssignPlaylistButton, {
        playlistId: playlistId,
        style: {
          width: '100%',
          fontWeight: 'normal',
          textDecoration: 'none'
        },
        tooltipProps: {
          placement: 'right'
        },
        use: "unstyled"
      })
    }), /*#__PURE__*/_jsx(CardMenuUnassignPlaylistOption, {
      onUnassigned: () => {
        trackUnassignedPlaylist();
        closeModal();
      },
      playlistId: playlistId
    }), /*#__PURE__*/_jsx(HR, {
      distance: "extra-small"
    }), /*#__PURE__*/_jsx(UISideNavItem, {
      linkComponent: "div",
      role: "navigation-item",
      title: /*#__PURE__*/_jsx(DuplicatePlaylistButton, {
        playlistId: playlistId,
        style: menuItemStyle,
        use: "unstyled"
      })
    }), /*#__PURE__*/_jsx(HR, {
      distance: "extra-small"
    }), /*#__PURE__*/_jsx(SavePlaylistButton, {
      language: language,
      onClick: closeModal,
      playlistId: playlistId,
      render: content => /*#__PURE__*/_jsx(UISideNavItem, {
        role: "navigation-item",
        title: content
      }),
      style: {
        width: '100%'
      }
    }), userIsOwner && /*#__PURE__*/_jsx(ArchivePlaylistButton, {
      language: language,
      onClick: closeModal,
      playlistId: playlistId,
      render: content => /*#__PURE__*/_jsx(UISideNavItem, {
        role: "navigation-item",
        title: content
      }),
      showTooltip: true,
      style: {
        width: '100%',
        marginLeft: 0
      }
    })]
  });
};
const ShortMenuOptions = ({
  shortId,
  closeModal,
  language
}) => {
  const onCreateNewClick = () => {
    trackCreateNewPlaylist(shortId, 'SHORT_FORM_CONTENT');
    closeModal();
  };
  const onAddToPlaylistClick = () => {
    trackAddToPlaylist(shortId, 'SHORT_FORM_CONTENT');
    closeModal();
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CardMenuWatchLaterOption, {
      language: language,
      onClick: closeModal,
      shortId: shortId
    }), /*#__PURE__*/_jsx(CardMenuAddToPlaylistOption, {
      language: language,
      onCreatePlaylistClick: onCreateNewClick,
      onPlaylistClick: onAddToPlaylistClick,
      shortId: shortId
    }), /*#__PURE__*/_jsx(HR, {
      distance: "extra-small"
    }), /*#__PURE__*/_jsx(SocialShareMenuOption, {
      language: language,
      onShare: closeModal,
      shortId: shortId
    })]
  });
};
const ShortMenuFooter = ({
  shortId,
  language = getLang(),
  closeModal
}) => {
  const onCreateNewClick = () => {
    closeModal();
    trackCreateNewPlaylist(shortId, 'SHORT_FORM_CONTENT');
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HR, {
      distance: "flush"
    }), /*#__PURE__*/_jsx(CreatePlaylistLink, {
      language: language,
      render: (content, to) => /*#__PURE__*/_jsx(CardMenuFooterLink, {
        onClick: onCreateNewClick,
        to: to,
        children: content
      }),
      shortId: shortId,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.cardMenu.addToNewPlaylist"
      })
    })]
  });
};
const DesktopCardMenu = _ref => {
  let {
      children,
      placement = 'bottom right',
      onOpenChange,
      isOpen,
      playlistId,
      trackId,
      lessonId,
      shortId,
      language
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const handleOnOpenChange = e => onOpenChange(e.target.value);
  const closeModal = () => onOpenChange(false);
  return /*#__PURE__*/_jsx(CardMenu, {
    content: {
      body: /*#__PURE__*/_jsxs(CardMenuOptions, {
        children: [playlistId && /*#__PURE__*/_jsx(PlaylistMenuOptions, Object.assign({
          closeModal: closeModal,
          language: language,
          playlistId: playlistId
        }, props)), (trackId || lessonId) && /*#__PURE__*/_jsx(TrackLessonMenuOptions, Object.assign({
          closeModal: closeModal,
          language: language,
          lessonId: lessonId,
          trackId: trackId
        }, props)), shortId && language && /*#__PURE__*/_jsx(ShortMenuOptions, Object.assign({
          closeModal: closeModal,
          language: language,
          shortId: shortId
        }, props))]
      }),
      footer: !playlistId && /*#__PURE__*/_jsxs(_Fragment, {
        children: [shortId && language && /*#__PURE__*/_jsx(ShortMenuFooter, {
          closeModal: closeModal,
          language: language,
          shortId: shortId
        }), (lessonId || trackId) && /*#__PURE__*/_jsx(TrackLessonMenuFooter, {
          closeModal: closeModal,
          lessonId: lessonId,
          trackId: trackId
        })]
      })
    },
    onOpenChange: handleOnOpenChange,
    open: isOpen,
    placement: placement,
    children: children
  });
};
export default DesktopCardMenu;